// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"markdown-styles_reactMarkDown__+t-XF","div":"markdown-styles_div__1X+HM"};